import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from "react-query";
import { regenerateSuggestion } from "@/services/tasks";
/**
 * Mutation hook to refine a suggestion with additional context. On success it
 * optimistically flips the cached suggestion to "generating" so the UI shows a
 * loader; the actual result arrives via the action_center_suggestion_updated
 * WebSocket signal, which refetches the suggestion.
 */
export function useRegenerateSuggestion(patientUid, reminderId) {
  var queryClient = useQueryClient();
  return useMutation(function (payload) {
    return regenerateSuggestion(patientUid, reminderId, payload);
  }, {
    onSuccess: function onSuccess() {
      queryClient.setQueryData(["action-center", patientUid, reminderId], function (prev) {
        return prev !== null && prev !== void 0 && prev.suggestion ? _objectSpread(_objectSpread({}, prev), {}, {
          suggestion: _objectSpread(_objectSpread({}, prev.suggestion), {}, {
            status: "generating",
            decisions: []
          })
        }) : prev;
      });
    },
    onError: function onError() {}
  });
}